// import AppImage from "@/common/base/AppImage";
import React from 'react';
import styles from './styles.module.css';
// import AppImage from "@/components/base/AppImage";
import getFileType from '@/functions/getFileType';
import AppImage from '@/components/common/AppImage';

const ImageSliderCard = ({ src, item }) => {
  return (
    <>
      {item && (
        <>
          {item?.type == 'image' || getFileType(item?.name) == 'image' ? (
            <AppImage
              src={src}
              containerclassName={`${styles.imageWrapper}`}
              alt={'favorite'}
              objectPosition="center center"
              className="w-full h-full"
              layout="fill"
              objectFit={`cover`}
              // height={125}
            />
          ) : (
            <video
              src={`${process.env.IMAGE_URL}${item?.name}`}
              className={`${styles.imageWrapper}`}
            />
          )}
          <div className={`${styles.absoluteIcon}`}>
            <AppImage
              src={
                item?.type == 'image' || getFileType(item?.name) == 'image'
                  ? '/imgs/shop/imageIcon.svg'
                  : '/imgs/shop/videoIcon.svg'
              }
              alt={'image'}
              objectPosition="center center"
              width={18}
              height={18}
            />
          </div>
        </>
      )}
    </>
  );
};

export default ImageSliderCard;
